import { SxProps } from "@mui/material";

export const dataTableListShell: SxProps = {
  height: "100%",
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
};

export const dataTablePageShell = (heightOffset: string): SxProps => ({
  height: heightOffset,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
});

/** Mixed-tab pages: scroll the whole tab area (dashboards, forms). Table tabs use CustomTabPanel2 inside. */
export const scrollableTabPageContent = (
  heightOffset: string,
  padding: number = 2.5,
): SxProps => ({
  p: padding,
  height: heightOffset,
  overflow: "auto",
});
